import { Form, Input } from "antd";
import React from "react";
import { store } from "../api/index";
import { submitForm } from "../redux/actions/contact";
import { useDispatch } from "react-redux";
import Breadcrumb from "../components/Breadcrumb";

const ContactScreen = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { TextArea } = Input;

  const onFinish = (values) => {
    let formData = {
      ...values,
      store,
    };
    dispatch(submitForm(formData));
    form.resetFields();
  };

  return (
    <div>
      <Breadcrumb heading={"Contact"} />
      <div className="container mx-auto py-20">
        <div className="flex items-center justify-center">
          <img src="/title-image.png" className="mb-4" alt="Flowers" />
        </div>
        <h2 className="heading_h2 text-center mb-10 mt-2">Contact us now</h2>
        <div className="login_part container mx-auto my-20">
          <div className="md:grid grid-cols-2 gap-20">
            <div className="login_part_text text-center py-20 px-10">
              <h2>Any Query?</h2>
              <p>
                There are advances being made in science and technology
                everyday, and a good example of this is the
              </p>
            </div>
            <div className="login_part_form p-4">
              <Form
                form={form}
                name="basic"
                onFinish={onFinish}
                requiredMark={false}
                layout="vertical"
                autoComplete="off"
              >
                <div className="md:grid grid-cols-2 gap-2">
                  <Form.Item
                    label="Name"
                    name="userName"
                    rules={[
                      {
                        required: true,
                        message: "Please input your name!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your email!",
                      },
                    ]}
                  >
                    <Input type="email" />
                  </Form.Item>
                </div>
                <Form.Item label="Phone" name="phone">
                  <Input type="number" />
                </Form.Item>
                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    {
                      required: true,
                      message: "Please input your message!",
                    },
                  ]}
                >
                  <TextArea rows={4} />
                </Form.Item>

                <button type="submit" className="info__button">
                  Submit
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactScreen;
